import { Base } from "ui/Scripts/source/framework/base";
import { ISortModifyUsersParams } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/user/modifyUser";

export interface IEventHandler {
    id: string;
    userCode: string;
    userName: string;
    userPicture: string;
    approveDate: number;
    modifyDate: number;

    isNew(): boolean;
}

export class EventHandler implements IEventHandler {
    id: string;
    userCode: string;
    userName: string;
    userPicture: string;
    approveDate: number;
    modifyDate: number;

    constructor();
    constructor(obj: IEventHandler);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.approveDate = obj && obj.approveDate || null;
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    isNew(): boolean {
        return this.modifyDate === 0;
    }

    static createEventHandler(userCode: string, userName: string, userPicture: string): EventHandler {
        const eventHandler = new EventHandler();
        eventHandler.id = Base.getGuid();
        eventHandler.userCode = userCode;
        eventHandler.userName = userName;
        eventHandler.userPicture = userPicture;
        return eventHandler;
    }

    static compareFunction(a: EventHandler, b: EventHandler): number {
        if (Base.isNullOrUndefined(a) && Base.isNullOrUndefined(b)) return 0;
        if (Base.isNullOrUndefined(a)) return -1;
        if (Base.isNullOrUndefined(b)) return 1;
        const userNameA = a.userName.toUpperCase(); // ignore upper and lowercase
        const userNameB = b.userName.toUpperCase(); // ignore upper and lowercase
        if (userNameA < userNameB) return -1;
        if (userNameA > userNameB) return 1;
        return 0;
    }

    static sortEventHandlers(items: IEventHandler[], { column = "name", asc = true, currentUserCode = null }: ISortModifyUsersParams = { column: "name", asc: true, currentUserCode: null }): IEventHandler[] {
        if (!items && items.length < 2) return items;
        let result: IEventHandler[];
        if (column === "code") {
            result = items.sort((a: IEventHandler, b: IEventHandler) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.userCode, b.userCode)); });
        } else if (column === "date") {
            result = items.sort((a: IEventHandler, b: IEventHandler) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.approveDate, b.approveDate)); });
        } else {
            result = items.sort((a: IEventHandler, b: IEventHandler) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.userName, b.userName)); });
        }
        if (currentUserCode) {
            result = Base.moveToFirst(result, result.findIndex(i => i.userCode === currentUserCode));
        }
        return result;
    }
}